export default __webpack_public_path__ + "static/media/amaze-15.74ed5d21.jpg";